<script lang="ts">
  import ExternalLinkIcon from '~icons/feather/external-link';
  import SplashLogo from '~/components/SplashLogo.svelte';
  import DiscordButton from '~/components/buttons/DiscordButton.svelte';
  import Feedback from '~/modals/Feedback.svelte';
  import ChangelogButton from '~/tutorial/ChangelogButton.svelte';
  import Settings from '~/modals/Settings.svelte';
  import AuthButton from '~/auth/AuthButton.svelte';
  import GameModeTile, { modes } from '~/components/GameModeTile.svelte';
  import { gameModeIn } from '~/animations.svelte';
  import ScrollShadow from '~/components/ScrollShadow.svelte';
  import { dims } from '~/utils/dimensions.svelte';
  import PremiumButton from '~/auth/PremiumButton.svelte';
  import DarkModeButton from '~/components/buttons/DarkModeButton.svelte';
  import LinkButton from '~/components/LinkButton.svelte';
</script>

<div class="header">
  <div class="header-group left">
    <AuthButton iconOnly />
    <PremiumButton iconOnly />
  </div>
  <SplashLogo animate />
  <div class="header-group right">
    <DarkModeButton />
    <Settings iconOnly />
  </div>
</div>
<div class="content" style:margin="0 -{dims.pad}px">
  <ScrollShadow>
    <div class="modes">
      {#each modes as mode, i}
        <div in:gameModeIn|global={{ delay: (i + 2) * 200 }}>
          <GameModeTile {mode} />
        </div>
      {/each}
    </div>
  </ScrollShadow>
</div>
<footer>
  <Feedback />
  <DiscordButton short />
  <ChangelogButton />
  <div class="conditions">
    <LinkButton href="/terms" outlink>
      <ExternalLinkIcon />Terms of Service</LinkButton
    >
    <LinkButton href="/privacy" outlink>
      <ExternalLinkIcon />Privacy Policy</LinkButton
    >
  </div>
</footer>

<style lang="scss">
  @use '~/theme/include-media' as *;
  .header {
    width: 720px;
    display: grid;
    justify-content: space-between;
    justify-items: center;
    align-items: start;
    grid-template-columns: auto 1fr auto;
    row-gap: 1rem;
    padding: 0.5rem;
    & .header-group {
      grid-row: 1;
      display: flex;
      flex-direction: row;
      gap: 0.5em;
    }
    & :global(.logo) {
      grid-row: 1;
      grid-column: 2;
    }
    & .right {
      grid-column: 3;
    }
    @include media('<=tablet') {
      width: 100%;
      max-width: 480px;
      grid-template-rows: auto auto;
      padding: 0;
      padding-bottom: 0.5rem;
      & :global(.logo) {
        transform: scale(0.8);
        grid-column: 1/4;
        grid-row: 2;
      }
    }
    @include media('<=420px') {
      & :global(.logo) {
        transform: scale(0.7);
      }
    }
    @include media('<=phone') {
      & :global(.logo) {
        transform: scale(0.6);
      }
    }
  }
  .content {
    height: 100%;
    overflow: auto;
  }
  .modes {
    height: 100%;
    overflow: auto;
    display: grid;
    overflow: auto;
    grid-template-columns: 1fr 1fr;
    padding: 1rem;
    gap: 1rem;
    max-width: 720px;
    @include media('<=tablet') {
      grid-template-columns: 1fr;
      max-width: 480px;
    }
    @include media('<=phone') {
      max-width: 360px;
    }
  }
  footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding-top: 0.5rem;
    gap: 1rem;
    @include media('<=tablet') {
      gap: 0.5rem;
    }
  }
  .conditions {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: -1em;
  }
</style>
